import React, { useState, useEffect } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { useNavigate } from '@reach/router';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import { Collapse } from '@mui/material';

import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import RedditIcon from '@mui/icons-material/Reddit';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import useTitle from '../../hooks/title'
import classes from './Pricing.module.scss'
import Layout from '../layout/Layout'
import ShareCard from '../share/ShareCard'
import Footer from '../footer/Footer'

// import subscribeStore from './subscribeStore';
import { getPlans } from './AccountAPI'
import useWindowSize from '../../hooks/window-size';

import userStore from '../common/userStore';
import { runInAction } from 'mobx';

const PLANS = [
  [<div>How do I know what plan I’m on?</div>,<div>Review your plan anytime in the plan section of your <a href="/account/plan">Plan page</a >.</div>],
  [<div>How do I cancel my plan?</div>,<div>You can cancel your plan at any time in the “Plan” section of your <a href="/account/plan">Plan page</a >. If you cancel, you will lose access to all remaining credits at the end of your billing cycle. You’ll keep access to your purchased and downloaded loops in the My Library section on the home page. </div>],
  [<div>What happens to my purchased samples if I cancel?</div>,<div>If you cancel your plan, you’ll still have access to your loops that were made or downloaded previously in the My Library section on the home page. Modifying and downloading existing loops doesn’t cost credits. </div>],
  [<div>Can I purchase more credits before my next payment?</div>,<div>Yes. Purchase more credits anytime by emailing us at <a href="mailto:support@sessionloops.com">support@sessionloops.com</a >. We will manually add credit for you. </div>],
  [<div>How many credits do I have left?</div>,<div>As long as you’re logged in, your remaining credits are always displayed next to your username in the top right corner of any page.</div>],
  [<div>Will I lose my credits after every billing cycle?</div>,<div>No. As long as your plan is active, all remaining credits will roll over.</div>],
  [<div>What happens to my Samples credits if I cancel?</div>,<div>You’ll lose all remaining credits at the end of your current billing cycle if you cancel.<br/>
      You’ll keep access to your purchased and downloaded sounds in the Downloads section of your account if you cancel. Modifying and downloading existing loops doesn’t cost credits.
      </div>]
]

const PlansPc = observer(({model}) => {
  const navigate = useNavigate()
  if (model.plans.length < 1) {
    return <div className={classes.plansPc}></div>
  }
  return <div className={classes.plansPc}>
    <div className={classes.head}>
      <h1>Plans & Pricing</h1>
      <Divider />
    </div>
    <div className={classes.plansItems}>
      <div className={classes.plansItem}>{" "}</div>
      {userStore.isLogin ? null : <div className={classes.plansItem}>
        <h3>Basic</h3>
        <div className={classes.plansPay}>Free</div>
        <Button variant="contained" disableElevation className={classes.button} onClick={() => navigate('/auth/signup')}>Get for free</Button>
      </div>}
      {model.plans.map((plan => (<div key={plan.id} className={classes.plansItem}>
        <h3>{plan.name}</h3>
        <div className={classes.plansPay}>${plan.price}<span className={classes.plansPeriod}>{plan.type == 0 ? '/mo':'/yr'}</span></div>
        <Button variant="contained" disableElevation className={classes.button} onClick={() => model.toCheckout(plan.id)}>
          {userStore.isLogin ? 'Get Plan' : 'Try for free for 14 days'}
        </Button>
      </div>)))}
    </div>
    <Divider className={classes.line} />
        <h2>Custom Packs</h2>
    <div className={classes.features}>
      <div className={clsx(classes.feature, classes.featureTitle)}>
        <div className={classes.row}>Browse & Share</div>
        <div className={classes.row}>Customize Loops <Tooltip arrow title="Customize grooves, chord changes, effects and more using our cloud-based Loop Editor"><InfoOutlinedIcon className={classes.info} /></Tooltip></div>
        <div className={classes.row}>Download & Credits</div>
      </div>
      {userStore.isLogin ? null : <div className={classes.feature}>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}>Share to get credits</div>
      </div>}
      {model.plans.map((plan => (<div key={plan.id} className={classes.feature}>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}>{plan.credit} {plan.type == 0 ? 'monthly':'yearly'} credits</div>
      </div>)))}
    </div>
    <h2>VocalNet</h2>
    <div className={classes.features}>
      <div className={clsx(classes.feature, classes.featureTitle)}>
        <div className={classes.row} style={{textAlign: 'left'}}>Voice Transformation</div>
        <div className={classes.row} style={{textAlign: 'left', width: 220}}>Voice Cloning</div>
      </div>
      {userStore.isLogin ? null : <div className={classes.feature}>
          <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          <div className={classes.row}></div>
      </div>}
      {model.plans.map((plan => (<div key={plan.id} className={classes.feature}>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
      </div>)))}
    </div>
    <h2>VocalNet Community</h2>
    <div className={classes.features}>
      <div className={clsx(classes.feature, classes.featureTitle)}>
        <div className={classes.row} style={{textAlign: 'left'}}>Capture Mode</div>
        <div className={classes.row} style={{textAlign: 'left', width: 220}}>File Mode</div>
      </div>
      {userStore.isLogin ? null : <div className={classes.feature}>
          <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          <div className={classes.row}></div>
      </div>}
      {model.plans.map((plan => (<div key={plan.id} className={classes.feature}>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
      </div>)))}
    </div>
    <h2>DrumNet</h2>
    <div className={classes.features}>
      <div className={clsx(classes.feature, classes.featureTitle)}>
        <div className={classes.row} style={{textAlign: 'left'}}>Generate Samples</div>
        <div className={classes.row} style={{textAlign: 'left', width: 220}}>Deep Resampling <Tooltip arrow title="Infinite Variations on Imported Samples"><InfoOutlinedIcon className={classes.info} /></Tooltip></div>
        <div className={classes.row} style={{textAlign: 'left', width: 220}}>Export Samples</div>
      </div>
      {userStore.isLogin ? null : <div className={classes.feature}>
          <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          <div className={classes.row}></div>
      </div>}
      {model.plans.map((plan => (<div key={plan.id} className={classes.feature}>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
        <div className={classes.row}><CheckIcon className={classes.checked} /></div>
      </div>)))}
    </div>
    <Divider className={classes.line} />
  </div>
})

const TabPanel = observer(({ children, value, index}) => {
  if (value != index) {
    return null
  }
  return <div className={classes.plansTab}>
    {children}
  </div>
})

const PlansMb = observer(({model}) => {
  const navigate = useNavigate()
  const state = useLocalObservable(() => ({
    _tabValue: -1,
    handleTabChange(event, newValue) {
      this._tabValue = newValue
      this.tipOpen = false
    },
    tipOpen: false,
    showTip() {
      this.tipOpen = true
    },
    hideTip() {
      this.tipOpen = false
    },
    get tabValue() {
      if (state._tabValue === -1) {
        return userStore.isLogin ? (model.plans.length > 0 ? model.plans[0].id : 1) : 0;
      }
      return state._tabValue
    }
  }))
  if (model.plans.length < 1) {
    return <div className={classes.plansMb}></div>
  }

  return <div className={classes.plansMb}>
    <h1>Plans & Pricing</h1>
    <div className={classes.plans}>
      <Tabs className={classes.plansTabs} value={state.tabValue} onChange={state.handleTabChange} centered variant="fullWidth">
        {userStore.isLogin ? null : <Tab label="Basic" value={0} />}
        {model.plans.map(plan => <Tab key={plan.id} label={plan.name} value={plan.id} />)}
      </Tabs>
      {userStore.isLogin ? null : <TabPanel value={state.tabValue} index={0}>
        <h2>Custom Packs</h2>
        <div className={classes.features}>
          <div className={classes.featureTitle}>
            <div>Browse & Share</div>
            <div>Customize Loops <Tooltip title="Customize grooves, chord changes, effects and more using our cloud-based Loop Editor" open={state.tipOpen} onClose={state.hideTip}>
                <InfoOutlinedIcon onClick={state.showTip} className={classes.info} /></Tooltip></div>
            <div>Download & Credits</div>
          </div>
          <div className={classes.feature}>
            <div><CheckIcon /></div>
            <div><CheckIcon /></div>
            <div>Share to get credits</div>
          </div>
        </div>
        <h2>VocalNet</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Voice Transformation</div>
            <div className={classes.row} style={{textAlign: 'left'}}>Voice Cloning</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}></div>
          </div>
        </div>
        <h2>VocalNet Community</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Capture Mode</div>
            <div className={classes.row} style={{textAlign: 'left'}}>File Mode</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}></div>
          </div>
        </div>
        <h2>DrumNet</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Generate Samples</div>
            <div className={classes.row} style={{textAlign: 'left'}}>Deep Resampling</div>
            <div className={classes.row} style={{textAlign: 'left'}}>Export Samples</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}></div>
          </div>
        </div>
        <Divider />
        <div className={classes.plansPayWrap}>
          <div className={classes.plansPay}>Free</div>
          <Button variant="contained" disableElevation className={classes.button} onClick={() => navigate('/auth/signup')}>Get for free</Button>
        </div>
        <Divider />
      </TabPanel>}
      {model.plans.map(plan => (<TabPanel key={plan.id} value={state.tabValue} index={plan.id}>
        <h2>Custom Packs</h2>
        <div className={classes.features}>
          <div className={classes.featureTitle}>
            <div>Browse & Share</div>
            <div>Customize Loops <Tooltip title="See Help" open={state.tipOpen} onClose={state.hideTip}>
                <InfoOutlinedIcon onClick={state.showTip} className={classes.info} /></Tooltip></div>
            <div>Download & Credits</div>
          </div>
          <div className={classes.feature}>
            <div><CheckIcon /></div>
            <div><CheckIcon /></div>
            <div>{plan.credit} {plan.type == 0 ? 'monthly':'yearly'} credits</div>
          </div>
        </div>
        <h2>VocalNet</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Voice Transformation</div>
            <div className={classes.row} style={{textAlign: 'left', whiteSpace: 'nowrap'}}>Voice Cloning</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          </div>
        </div>
        <h2>VocalNet Community</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Capture Mode</div>
            <div className={classes.row} style={{textAlign: 'left', whiteSpace: 'nowrap'}}>File Mode</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          </div>
        </div>
        <h2>DrumNet</h2>
        <div className={classes.features}>
          <div className={clsx(classes.feature, classes.featureTitle)}>
            <div className={classes.row} style={{textAlign: 'left'}}>Generate Samples</div>
            <div className={classes.row} style={{textAlign: 'left', whiteSpace: 'nowrap'}}>Deep Resampling</div>
            <div className={classes.row} style={{textAlign: 'left', whiteSpace: 'nowrap'}}>Export Samples</div>
          </div>
          <div className={classes.feature}>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
            <div className={classes.row}><CheckIcon className={classes.checked} /></div>
          </div>
        </div>
        <Divider />
        <div className={classes.plansPayWrap}>
          <div className={classes.plansPay}>${plan.price}<span className={classes.plansPeriod}>{plan.type == 0 ? '/mo':'/yr'}</span></div>
          <Button variant="contained" disableElevation className={classes.button} onClick={() => model.toCheckout(plan.id)}>
          {userStore.isLogin ? 'Get Plan' : 'Try for free for 14 days'}
          </Button>
        </div>
        <Divider />
      </TabPanel>))}
    </div>
  </div>
})

const Plans = observer(() => {
  const navigate = useNavigate()
  const { width } = useWindowSize()
  const model = useLocalObservable(() => ({
    plans: [],
    async loadPlans() {
      try {
        const rs = await getPlans()
        runInAction(() => this.plans = rs)
      } catch (e) {
        console.log(e)
      }
    },
    toCheckout(id) {
      // signup
      if (userStore.isLogin) {
        navigate(`/account/checkout?plan-id=${id}`)
        return;
      }
      navigate(`/auth/signup?rd=${encodeURIComponent('/account/checkout?plan-id='+id)}`)
    }
  }))
  useEffect(() => {
    model.loadPlans()
  }, [model.loadPlans])

  return width >= 875 ? <PlansPc model={model} /> : <PlansMb model={model} />
})


const Share = observer(() => {

  return <div className={classes.share}>
    <h1>Share & Get Free Loops</h1>
    <h3>Share loops with your friends via</h3>
    <div className={classes.shareTypes}>
      <div className={clsx(classes.iconWrap, classes.facebook)}><FacebookOutlinedIcon /></div>
      <div className={clsx(classes.iconWrap, classes.twitter)}><TwitterIcon /></div>
      <div className={clsx(classes.iconWrap, classes.reddit)}><RedditIcon /></div>
      <div className={clsx(classes.iconWrap, classes.link)}><InsertLinkIcon /></div>
    </div>
    <div className={classes.shareDesc}>With every single stream get 1 free credit from share, up to 15 credits per month.</div>
  </div>
})

const FAQ = observer(() => {

  function FaqItem(title, content, index, hasDivider)
  {
    //const {title, content} = props;
    const [open, setOpen] = useState(false);
    return (
      <div className={classes['item']} key={index}>
            <div className={classes['item-title']} onClick={() => setOpen(!open)}>
              {title}
              <div className={classes['item-arrow']}>{open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</div>
            </div>
            <Collapse in={open}>
                <div className={classes['item-content']}>{content}</div>
            </Collapse>
            {hasDivider && <div className={classes['item-divider']} />}
      </div>
    );
  }

  return <div className={classes.faq}>
    <h1>Frequently asked questions</h1>
    {PLANS.map((item, index) => FaqItem(item[0], item[1], index, index < PLANS.length - 1))}
  </div>
})


const Pricing = observer(() => {
  useTitle('Plans & Pricing', 'Choose the Session Loops plan that fits your workflow. Flexible pricing for hobbyists, producers, and professional studios.', '/pricing')
  return <>
    <Layout className={classes.root}>
      <Plans />
      <Share />
      <FAQ />
    </Layout>
    {userStore.isLogin ? null : <ShareCard className={classes.shareCard} />}
    <Footer />
  </>
})

export default Pricing
